/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

/**
 * Retrieve a single deployment, including its status and runtime configuration.
 */
export type V1DeploymentsGetDeploymentRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  deploymentId: string;
};

/** @internal */
export type V1DeploymentsGetDeploymentRequestBody$Outbound = {
  deploymentId: string;
};

/** @internal */
export const V1DeploymentsGetDeploymentRequestBody$outboundSchema: z.ZodType<
  V1DeploymentsGetDeploymentRequestBody$Outbound,
  z.ZodTypeDef,
  V1DeploymentsGetDeploymentRequestBody
> = z.object({
  deploymentId: z.string(),
});

export function v1DeploymentsGetDeploymentRequestBodyToJSON(
  v1DeploymentsGetDeploymentRequestBody: V1DeploymentsGetDeploymentRequestBody,
): string {
  return JSON.stringify(
    V1DeploymentsGetDeploymentRequestBody$outboundSchema.parse(
      v1DeploymentsGetDeploymentRequestBody,
    ),
  );
}
